import MicroModal from "micromodal"

const Modal = ({modalId, buttonTitle, classNames, children }) => {
  MicroModal.init()

  const hasClassNames = classNames ? classNames : "button"
  
  return (
   <>
      {
        buttonTitle !== '' && (
          <a className={ hasClassNames } onClick={() => MicroModal.show( modalId )}>{ buttonTitle }</a>
        )
      }

      <div className="msync-modal" id={ modalId } aria-hidden="true" data-msync-micromodal-animation="slide">
        <div className="msync-modal__overlay" tabindex="-1">
          <div className="msync-modal__container" role="dialog" aria-modal="true" aria-labelledby={ `${modalId}-label` }>
            { children }
          </div>
        </div>
      </div>

    </>
  )
}

export default Modal